import { FormHelperText as MUIFormHelperText } from '@material-ui/core';
const FormHelperText = MUIFormHelperText;
export default FormHelperText;
